import React from 'react';
import {
  Box,
  Card,
  Button,
  TextField,
  MenuItem,
  Paper,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography
} from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { format } from 'date-fns';
import Client from '../Client';
import BackofficeReportsApi from './backofficeReportsApi';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';

let d = new Date();
const getISODay = d => (d.getDay() + 6) % 7 + 1;

let today = format(d, 'yyyy-MM-dd');
let yesterday = format(new Date(new Date(d).setDate(d.getDate() - 1)), 'yyyy-MM-dd');
let d1Month = format(new Date(d.getFullYear(), d.getMonth(), 1), 'yyyy-MM-dd');
let d1Week = format(new Date(new Date(d).setDate(d.getDate() - getISODay(d) + 1)), 'yyyy-MM-dd');

function thousandsSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function addDays(date, days) {
  if (date) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    result = format(result, 'yyyy-MM-dd');
    return result;
  }
}

const period = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'week', label: 'This Week' },
  { value: 'month', label: 'This Month' },
  { value: 'custom', label: 'Custom' }
];

const objectToCsv = function (data) {
  const csvRows = [];

  if (!data || !data.length) {
    return "No data";
  }

  const headers = Object.keys(data[0]);
  csvRows.push(headers.join(','));

  for (const row of data) {
    const values = headers.map(header => {
      const val = row[header];
      return `"${val}"`;
    });

    csvRows.push(values.join(','));
  }

  return csvRows.join('\n');
};

class ProductChartGroup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      saleslocation_list: [],
      salesproduct_list: { result: [] },
      page: 0,
      rowsPerPage: -1,

      dateFrom: today,
      dateTo: today,

      location: 0,
      locationName: { iref: 0, name: "All Locations" },

      delivery: 2,
      salesType: 'products',

      sx_hidden: { display: 'none' },
      value: "1",

      locations: [{ iref: 0, name: "All Locations" }],

      deliverys: [
        { iref: 2, name: "All" },
        { iref: 0, name: "Restaurant" },
        { iref: 1, name: "Delivery" }
      ],

      filterData: {},
      productSearch: ''
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.addDateFrom = this.addDateFrom.bind(this);
    this.addDateTo = this.addDateTo.bind(this);
    this.selectPeriod = this.selectPeriod.bind(this);
    this.selectLocation = this.selectLocation.bind(this);
    this.selectDelivery = this.selectDelivery.bind(this);
    this.selectSalesType = this.selectSalesType.bind(this);
    this.handleProductSearch = this.handleProductSearch.bind(this);

    this.queryData = {};
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    const queryData = {
      location: this.state.location,
      delivery: this.state.delivery,
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo,
      salesType: this.state.salesType || 'products'
    };

    const data = BackofficeReportsApi.getSalesByProduct(this.state.client, queryData);

    if (data) {
      this.setState({ salesproduct_list: data });
    } else {
      this.setState({ salesproduct_list: { result: [] } });
    }

    this.setState({ filterData: queryData });

    const locations = BackofficeReportsApi.getLocations(this.state.client);

    if (locations && Array.isArray(locations.locations)) {
      this.setState({ locations: locations.locations });
    } else if (Array.isArray(locations)) {
      this.setState({ locations: locations });
    }
  }

  doSync() {
    this.getData();
    this.setState({ page: 0 });
  }

  addDateFrom = (event) => {
    this.setState({
      dateFrom: event.target.value,
      dateTo: event.target.value
    });
  }

  addDateTo = (event) => {
    this.setState({ dateTo: event.target.value });
  }

  handleProductSearch = (event) => {
    this.setState({
      productSearch: event.target.value,
      page: 0
    });
  }

  selectPeriod = (event) => {
    switch (event.target.value) {
      case "today":
        this.setState(
          {
            sx_hidden: { display: 'none' },
            dateFrom: today,
            dateTo: today
          },
          function () {
            this.doSync();
          }
        );
        break;

      case "yesterday":
        this.setState(
          {
            sx_hidden: { display: 'none' },
            dateFrom: yesterday,
            dateTo: yesterday
          },
          function () {
            this.doSync();
          }
        );
        break;

      case "week":
        this.setState(
          {
            sx_hidden: { display: 'none' },
            dateFrom: d1Week,
            dateTo: today
          },
          function () {
            this.doSync();
          }
        );
        break;

      case "month":
        this.setState(
          {
            sx_hidden: { display: 'none' },
            dateFrom: d1Month,
            dateTo: today
          },
          function () {
            this.doSync();
          }
        );
        break;

      default:
        this.setState(
          { sx_hidden: {} },
          function () {
            this.doSync();
          }
        );
        break;
    }
  }

  selectLocation = (event) => {
    const value = event.target.value;

    const locationObj = this.state.locations.find(
      (o) => String(o.iref) === String(value)
    );

    this.setState(
      {
        location: value,
        locationName: locationObj || { iref: 0, name: "All Locations" },
        page: 0
      },
      function () {
        this.doSync();
      }
    );
  }

  selectDelivery = (event) => {
    this.setState(
      {
        delivery: event.target.value,
        page: 0
      },
      function () {
        this.doSync();
      }
    );
  }

  selectSalesType = (event, value) => {
    if (!value) {
      return;
    }

    this.setState(
      {
        salesType: value,
        productSearch: '',
        page: 0
      },
      function () {
        this.doSync();
      }
    );
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({
      rowsPerPage: +event.target.value,
      page: 0
    });
  }

  onDownload = () => {
    const rows = this.state.salesproduct_list?.result || [];
    const locName = this.state.locationName?.name || "All Locations";
    const reportLabel = this.state.salesType === 'combos' ? 'Combo Sales' : 'Product Sales';
    const filePrefix = this.state.salesType === 'combos' ? 'comboSales' : 'productSales';

    const csvHeader = `${reportLabel}
Date From: ${this.state.dateFrom}
Date To: ${this.state.dateTo}
Location: ${locName}`;

    const csvBody = rows.length ? objectToCsv(rows) : "No data";
    const csv = "\uFEFF" + csvHeader + "\n" + csvBody;

    const link = document.createElement("a");
    link.download = `${filePrefix}_${locName}_${this.state.dateFrom}_${this.state.dateTo}.csv`;
    link.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
    link.click();
  };

  filterSx(widthConfig) {
    return {
      width: widthConfig,
      minWidth: 0,
      '& .MuiInputBase-root': {
        height: 36,
        borderRadius: '12px',
        fontSize: {
          xs: '0.82rem',
          sm: '0.88rem',
        },
        bgcolor: '#fff',
      },
      '& .MuiInputBase-input': {
        fontSize: {
          xs: '16px',
          sm: '0.88rem',
        },
        py: 0.35,
      },
      '& .MuiInputLabel-root': {
        fontSize: {
          xs: '0.76rem',
          sm: '0.82rem',
        },
      },
    };
  }

  render() {
    let locations = [{ iref: 0, name: "All Locations" }];

    if (Array.isArray(this.state.locations)) {
      this.state.locations.forEach((fData) => {
        if (
          fData &&
          fData.iref !== undefined &&
          String(fData.iref) !== "0"
        ) {
          locations.push({
            iref: fData.iref,
            name: fData.name
          });
        }
      });
    }

    let deliverys = [
      { iref: 2, name: "All" },
      { iref: 0, name: "Restaurant" },
      { iref: 1, name: "Delivery" }
    ];

    let productSalesData = [];
    let productSalesList = [];

    if (this.state.salesproduct_list && this.state.salesproduct_list.result) {
      let counter = 0;

      Object.keys(this.state.salesproduct_list.result).forEach(key => {
        let fData = this.state.salesproduct_list.result[key];

        let myData = {
          x: fData.name,
          y: parseInt(fData.value || 0)
        };

        let p = {
          id: counter + 1,
          name: fData.name || '',
          quantity: thousandsSeparator(fData.quantity || 0),
          value: thousandsSeparator(parseInt(fData.value || 0))
        };

        if (counter < 10) {
          productSalesData.push(myData);
        }

        counter += 1;
        productSalesList.push(p);
      });
    }

    const filteredProductSalesList = productSalesList.filter((product) =>
      product.name
        .toLowerCase()
        .includes(this.state.productSearch.toLowerCase())
    );

    const isComboSales = this.state.salesType === "combos";

    const tableContainerSx = {
      flex: 1,
      minHeight: 0,
      overflow: 'auto',
      borderTop: '1px solid rgba(15, 23, 42, 0.06)',
      '&::-webkit-scrollbar': {
        height: 8,
        width: 8,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(15, 23, 42, 0.18)',
        borderRadius: 999,
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'rgba(15, 23, 42, 0.04)',
      },
    };

    const tableSx = {
      minWidth: {
        xs: '100%',
        sm: 520,
        md: '100%',
      },
      width: '100%',
      tableLayout: 'fixed',
      '& .MuiTableCell-root': {
        borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
        fontSize: {
          xs: '0.72rem',
          sm: '0.84rem',
          md: '0.92rem',
        },
      },
      '& .MuiTableRow-hover:hover': {
        backgroundColor: 'rgba(26, 35, 126, 0.035)',
      },
    };

    const headerCellSx = {
      py: {
        xs: 0.45,
        sm: 0.85,
      },
      px: {
        xs: 0.35,
        sm: 1,
      },
      bgcolor: '#f8fafc',
      color: '#1a237e',
      fontWeight: 650,
      lineHeight: 1.1,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    };

    const bodyCellSx = {
      py: {
        xs: 0.45,
        sm: 0.8,
      },
      px: {
        xs: 0.35,
        sm: 1,
      },
      whiteSpace: 'nowrap',
      color: '#111827',
      fontWeight: 450,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontVariantNumeric: 'tabular-nums',
    };

    const nameCellSx = {
      ...bodyCellSx,
      position: 'sticky',
      left: 0,
      zIndex: 2,
      bgcolor: '#fff',
      fontWeight: 550,
      fontVariantNumeric: 'normal',
    };

    const nameHeaderCellSx = {
      ...headerCellSx,
      position: 'sticky',
      left: 0,
      zIndex: 4,
    };

    const paginationSx = {
      flexShrink: 0,
      borderTop: '1px solid rgba(15, 23, 42, 0.06)',
      bgcolor: '#fff',
      minHeight: {
        xs: 44,
        sm: 52,
      },
      '& .MuiTablePagination-toolbar': {
        minHeight: {
          xs: 44,
          sm: 52,
        },
        px: {
          xs: 0.5,
          sm: 1,
        },
        flexWrap: {
          xs: 'wrap',
          sm: 'nowrap',
        },
        gap: {
          xs: 0.25,
          sm: 0.5,
        },
      },
      '& .MuiTablePagination-spacer': {
        display: {
          xs: 'none',
          sm: 'block',
        },
      },
      '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
        fontSize: {
          xs: '0.88rem',
          sm: '0.92rem',
          md: '1rem',
        },
        m: 0,
      },
      '& .MuiTablePagination-actions': {
        ml: {
          xs: 0,
          sm: 1,
        },
      },
      '& .MuiTablePagination-actions button': {
        p: {
          xs: 0.25,
          sm: 1,
        },
      },
    };

    return (
      <Paper
        sx={{
          position: 'relative',
          width: '100%',
          height: {
            xs: 600,
            sm: 600,
            md: 620,
            lg: 640,
          },
          maxHeight: {
            xs: 600,
            sm: 600,
            md: 620,
            lg: 640,
          },
          minHeight: 0,
          borderRadius: {
            xs: '14px',
            sm: '16px',
          },
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
          border: '1px solid rgba(15, 23, 42, 0.06)',
          bgcolor: '#fff',
        }}
      >
        <Card
          sx={{
            height: '100%',
            minHeight: 0,
            borderRadius: 0,
            boxShadow: 'none',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          {/* Filters */}
          <Box
            sx={{
              px: {
                xs: 0.75,
                sm: 1,
              },
              py: {
                xs: 0.65,
                sm: 0.85,
              },
              flexShrink: 0,
              borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
              bgcolor: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: {
                  xs: 'stretch',
                  sm: 'center',
                },
                justifyContent: 'space-between',
                gap: {
                  xs: 0.75,
                  sm: 1,
                },
                flexDirection: {
                  xs: 'column',
                  sm: 'row',
                },
              }}
            >
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  sx={{
                    color: '#1a237e',
                    fontWeight: 800,
                    fontSize: {
                      xs: '0.9rem',
                      sm: '1rem',
                    },
                    lineHeight: 1.2,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {isComboSales ? 'Combo Sales' : 'Product Sales'}
                </Typography>

                <Typography
                  sx={{
                    mt: 0.15,
                    color: '#64748b',
                    fontWeight: 600,
                    fontSize: {
                      xs: '0.72rem',
                      sm: '0.78rem',
                    },
                    lineHeight: 1.2,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {/* Sales quantity and value by {isComboSales ? 'combo' : 'product'} */}
                  Sales quantity and value by {isComboSales ? 'combo' : 'product'}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: {
                    xs: 'space-between',
                    sm: 'flex-end',
                  },
                  gap: 0.75,
                  flexWrap: 'wrap',
                }}
              >
                <TextField
                  id="standard-select-period"
                  select
                  defaultValue="today"
                  size="small"
                  sx={this.filterSx({
                    xs: 132,
                    sm: 130,
                  })}
                  onChange={this.selectPeriod}
                >
                  {period.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  id="standard-select-location"
                  select
                  value={this.state.location}
                  size="small"
                  sx={{
                    ...this.filterSx({
                      xs: 'calc(100% - 180px)',
                      sm: 180,
                      md: 210,
                      lg: 220,
                    }),
                    maxWidth: {
                      xs: '100%',
                      md: 230,
                    },
                    flex: {
                      xs: '1 1 calc(100% - 180px)',
                      sm: '0 1 180px',
                      md: '0 1 210px',
                      lg: '0 0 220px',
                    },
                  }}
                  onChange={this.selectLocation}
                >
                  {locations.map((option) => (
                    <MenuItem key={option.iref} value={option.iref}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  id="standard-select-delivery"
                  select
                  value={this.state.delivery}
                  size="small"
                  sx={this.filterSx({
                    xs: 108,
                    sm: 112,
                  })}
                  onChange={this.selectDelivery}
                >
                  {deliverys.map((option) => (
                    <MenuItem key={option.iref} value={option.iref}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>

                <Box
                  sx={{
                    width: {
                      xs: 154,
                      sm: 156,
                    },
                    flexShrink: 0,
                  }}
                >
                  <ToggleButtonGroup
                    exclusive
                    size="small"
                    value={this.state.salesType}
                    onChange={this.selectSalesType}
                    sx={{
                      width: '100%',
                      height: 36,
                      borderRadius: '12px',
                      overflow: 'hidden',
                      '& .MuiToggleButton-root': {
                        flex: 1,
                        px: {
                          xs: 0.75,
                          sm: 1,
                        },
                        py: 0.35,
                        minHeight: 36,
                        fontSize: {
                          xs: '0.76rem',
                          sm: '0.82rem',
                        },
                        fontWeight: 650,
                        textTransform: 'none',
                        borderColor: 'rgba(26, 35, 126, 0.12)',
                        color: '#1a237e',
                      },
                      '& .Mui-selected': {
                        backgroundColor: 'rgba(26, 35, 126, 0.08)',
                        color: '#1a237e',
                      },
                      '& .Mui-selected:hover': {
                        backgroundColor: 'rgba(26, 35, 126, 0.12)',
                      },
                    }}
                  >
                    <ToggleButton value="products">
                      Products
                    </ToggleButton>

                    <ToggleButton value="combos">
                      Combos
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Box>

                <Tooltip title="Download CSV">
                  <Button
                    size="small"
                    onClick={this.onDownload}
                    variant="contained"
                    sx={{
                      minWidth: 36,
                      width: 36,
                      height: 36,
                      p: 0,
                      flexShrink: 0,
                      borderRadius: '12px',
                      color: '#1a237e',
                      bgcolor: 'rgba(26, 35, 126, 0.08)',
                      boxShadow: 'none',
                      border: '1px solid rgba(26, 35, 126, 0.12)',
                      '&:hover': {
                        bgcolor: 'rgba(26, 35, 126, 0.12)',
                        boxShadow: 'none',
                      },
                    }}
                  >
                    <FileDownloadIcon fontSize="small" />
                  </Button>
                </Tooltip>
              </Box>
            </Box>

            <Box
              sx={{
                ...this.state.sx_hidden,
                mt: 0.85,
                alignItems: 'center',
                gap: 0.75,
                flexWrap: 'wrap',
              }}
            >
              <TextField
                size="small"
                id="date-from"
                label="From"
                type="date"
                value={this.state.dateFrom}
                sx={this.filterSx({
                  xs: 'calc(50% - 24px)',
                  sm: 130,
                })}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  min: "2020-01-01",
                  style: {
                    paddingRight: 5,
                    paddingLeft: 5
                  }
                }}
                onChange={this.addDateFrom}
              />

              <TextField
                size="small"
                id="date-to"
                label="To"
                type="date"
                value={this.state.dateTo}
                sx={this.filterSx({
                  xs: 'calc(50% - 24px)',
                  sm: 130,
                })}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  min: "2020-01-01",
                  max: addDays(this.state.dateFrom, 50),
                  style: {
                    paddingRight: 5,
                    paddingLeft: 5
                  }
                }}
                onChange={this.addDateTo}
              />

              <Tooltip title="Refresh">
                <Button
                  onClick={() => this.doSync()}
                  variant="contained"
                  sx={{
                    minWidth: 36,
                    width: 36,
                    height: 36,
                    p: 0,
                    flexShrink: 0,
                    borderRadius: '12px',
                    boxShadow: 'none',
                    '&:hover': {
                      boxShadow: 'none',
                    },
                  }}
                >
                  <AutorenewIcon fontSize="small" />
                </Button>
              </Tooltip>
            </Box>
          </Box>

          {/* Search */}
          <Box
            sx={{
              flexShrink: 0,
              px: {
                xs: 0.75,
                sm: 1,
              },
              py: {
                xs: 0.65,
                sm: 0.85,
              },
              borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
            }}
          >
            <TextField
              size="small"
              label={isComboSales ? "Search combo" : "Search product"}
              variant="outlined"
              value={this.state.productSearch}
              onChange={this.handleProductSearch}
              fullWidth
              sx={{
                '& .MuiInputBase-root': {
                  height: 36,
                  borderRadius: '12px',
                  fontSize: {
                    xs: '0.82rem',
                    sm: '0.88rem',
                  },
                  bgcolor: '#fff',
                },
                '& .MuiInputBase-input': {
                  fontSize: {
                    xs: '16px',
                    sm: '0.88rem',
                  },
                  py: 0.35,
                },
                '& .MuiInputLabel-root': {
                  fontSize: {
                    xs: '0.76rem',
                    sm: '0.82rem',
                  },
                },
              }}
              InputProps={{
                endAdornment: this.state.productSearch && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => this.setState({ productSearch: '', page: 0 })}
                      edge="end"
                      size="small"
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </Box>

          {/* Table + Pagination */}
          <TableContainer sx={tableContainerSx}>
            <Table stickyHeader aria-label="product sales table" size="small" sx={tableSx}>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      ...nameHeaderCellSx,
                      width: {
                        xs: '54%',
                        sm: '56%',
                        md: '56%',
                      },
                    }}
                  >
                    {isComboSales ? "Combo" : "Product"}
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{
                      ...headerCellSx,
                      width: {
                        xs: '23%',
                        sm: '22%',
                        md: '22%',
                      },
                    }}
                  >
                    Quantity
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{
                      ...headerCellSx,
                      width: {
                        xs: '23%',
                        sm: '22%',
                        md: '22%',
                      },
                    }}
                  >
                    Value
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {(this.state.rowsPerPage > 0
                  ? filteredProductSalesList.slice(
                    this.state.page * this.state.rowsPerPage,
                    this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
                  )
                  : filteredProductSalesList
                ).map((product) => {
                  return (
                    <TableRow
                      hover
                      key={product.id}
                      tabIndex={-1}
                    >
                      <TableCell
                        sx={{
                          ...nameCellSx,
                          width: {
                            xs: '54%',
                            sm: '56%',
                            md: '56%',
                          },
                        }}
                      >
                        {product.name}
                      </TableCell>

                      <TableCell align="right" sx={bodyCellSx}>
                        {product.quantity}
                      </TableCell>

                      <TableCell align="right" sx={bodyCellSx}>
                        {product.value}
                      </TableCell>
                    </TableRow>
                  );
                })}

                {filteredProductSalesList.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      <Box
                        sx={{
                          py: 4,
                          color: 'text.secondary',
                          fontSize: {
                            xs: '0.86rem',
                            sm: '0.92rem',
                          },
                        }}
                      >
                        No data
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[10, 25, { value: -1, label: 'All' }]}
            labelRowsPerPage="Rows:"
            component="div"
            count={filteredProductSalesList.length}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            sx={paginationSx}
          />
        </Card>
      </Paper>
    );
  }
}

export default ProductChartGroup;
